<template>
    <div>
        <b-overlay :show="isLoading">
            <div class="d-flex flex-wrap" style="width: 100%;">
                <div class="mt-1 card-title">
                    Tasks
                </div>
                &nbsp;
                <b-button class="ms-3 thin-button" @click="showModal" variant="primary" size="sm">
                    <i class="fas fa-plus"></i>  Add Task
                </b-button>
                

            </div>


            <hr>

            <span class="card-title">Admin Tasks</span>
            &nbsp;
            <b-button size="sm" @click="showModal" variant="primary">
                <i class="fas fa-plus"></i>  Add Task
            </b-button>

            <b-row v-if="adminTasks.length > 0">
                <b-col cols="4" v-for="task in adminTasks" :key="task.id">
                    <div class="p-2 mb-1" style="border: 1px solid grey; border-radius: 0.4rem;">
                        <p>{{task.body}}</p>
                        <b-button size="sm" variant="outline-success">
                            <i class="fas fa-check"></i>
                        </b-button>&nbsp;
                        <b-button @click="removeTask(task.id)" size="sm" variant="outline-danger">
                            <i class="fas fa-trash"></i>
                        </b-button>
                    </div>
                </b-col>
                <!--<b-col cols="6">
                    <h6>Client Tasks</h6>
                    <b-col cols="3" v-for="task in clientTasks" :key="task.id">
                        {{task}}
                    </b-col>
                </b-col>
                -->
            </b-row>

        </b-overlay>

        <TaskModal :users="clients" @saved="saveTask" @exit="show_modal = false;" v-if="show_modal" />

    </div>
</template>

<script>
import TaskModal from '@/components/steps/addTaskModal.vue'
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        isLoading: false,
        show_modal: false,
        params:{
            client_id: '',//this.client_data.client.id,
            step_id: '',//this.client_step_data.id,
            step_validation_id: null,
            type:'user_task',//admin_task
            due_date: null,
            task_user_id: null,
            body: 'Task user'
        }
    }),
    components:{
        TaskModal,
    },
    computed:{
        ...ccbAdminState,
        adminTasks(){
            let tasks = [];
            if(this.client_step_data != null){
                tasks = this.client_step_data.admin_tasks;
            }
            return tasks;
        },
        clientTasks(){
            let tasks = [];
            if(this.client_step_data != null){
                tasks = this.client_step_data.client_tasks;
            }
            return tasks;
        },
        clients(){
            let data = [];
            if(this.client_data != null){
                this.client_data.users.forEach( user => {
                    data.push(user.name);
                })
            }
            return data;
        }
    },
    methods:{
        ...ccbAdminMethods,
        /*eslint-disable-next-line */
        saveTask(data){
            this.isLoading = true;
            this.params.client_id = this.client_data.client.id;
            this.params.step_id = this.client_step_data.id;
            this.params.body = data.body;
            this.params.type = data.type;

            this.addTask(this.params)
            .then(()=>{
                this.show_modal = false;
                let step_params = {
                    client_id: this.client_data.client.id,
                    step_id: this.client_step_data.id,
                }
                this.loadClientStepData(step_params)
                .then(()=>{
                    this.isLoading = false;
                })
                .catch(()=>{
                    this.isLoading = false;
                })
            })
            .catch(()=>{
                this.isLoading = false;
            })
        },
        removeTask(id){
            this.isLoading = true;
            this.deleteStepAction({id:id})
            .then(()=>{
                let step_params = {
                    client_id: this.client_data.client.id,
                    step_id: this.client_step_data.id,
                }
                this.loadClientStepData(step_params)
                .then(()=>{
                    this.isLoading = false;
                })
                .catch(()=>{
                    this.isLoading = false;
                })
            })
            .catch(()=>{
                this.isLoading = false;
            })
        },
        showModal(){
            this.show_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('taskModal');
            })
        },
        addTasks(){
            /*let p1 = {
                client_id: this.client_data.client.id,
                step_id: this.client_step_data.id,
                step_validation_id: null,
                type: 'user_task',
                due_date: null,
                task_user_id: null,
                body: 'Task user'
            }*/

            let p2 = {
                client_id: this.client_data.client.id,
                step_id: this.client_step_data.id,
                step_validation_id: null,
                type: 'admin_task',
                due_date: null,
                task_user_id: null,
                body: 'Task admin'
            }
            
            //this.addUserTask(p1);
            this.addTask(p2);
        }
    },
    mounted(){},
}
</script>

<style>

</style>